import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import ButtonInput from "../Components/Button_Components/ButtonInput";
// import ErrorIcon from '@mui/icons-material/Error';

export default function PopupModal({ data }) {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  React.useMemo(() => {
    if (data?.error) {
      setOpen(true);
    }
  }, [data]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <DialogContentText sx={{ fontSize: "18px " }}>
            {data && data?.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonInput title="Cancel" onClick={handleClose} />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
